// extracted by mini-css-extract-plugin
module.exports = {"list":"Navigation_list__VwUiO","list_desktop":"Navigation_list_desktop__Y14D7"};